module.exports = __webpack_public_path__ + "static/media/mapCloud_1.ace59773.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mapCloud_1.png
// module id = 855
// module chunks = 0